import reporter from "../report/reporter";
import { getPage } from "../shared/global";
import { getAttribute } from "./get";

export function dialog_expose(targetNode) {
  const page = getPage();
  const trackData = {
    event_id: 39012,
    event_name: "dialog_expose",
    title: getAttribute(targetNode, "data-dialog-title"),
    ...page,
  };
  const { page_nm, sub_page_nm } = page;
  var source = getAttribute(targetNode, "data-content-source");

  if (source) {
    trackData.source = `${page_nm}_${sub_page_nm || ""}_${source}`;
  } else {
    trackData.source = sub_page_nm ? `${page_nm}_${sub_page_nm}` : page_nm;
  }

  var account_type = getAttribute(targetNode, "data-account-type");
  if (account_type) {
    trackData.account_type = account_type;
  }
  let plan_id = getAttribute(targetNode, "data-plan-id");
  if (plan_id) {
    trackData.plan_id = plan_id;
  }
  let create_id = getAttribute(targetNode, "data-create-id");
  if (create_id) {
    trackData.create_id = create_id;
  }
  reporter(trackData);
}

export function dialog_action(targetNode) {
  const page = getPage();
  const trackData = {
    event_id: 39013,
    event_name: "dialog_action",
    title: getAttribute(targetNode, "data-dialog-title"),
    action_type: getAttribute(targetNode, "data-dialog-action"),
    ...page,
  };
  const { page_nm, sub_page_nm } = page;
  var source = getAttribute(targetNode, "data-content-source");

  if (source) {
    trackData.source = `${page_nm}_${sub_page_nm || ""}_${source}`;
  } else {
    trackData.source = sub_page_nm ? `${page_nm}_${sub_page_nm}` : page_nm;
  }

  var message_id = getAttribute(targetNode, "data-message-id");
  if (message_id) {
    trackData.message_id = message_id;
  }

  var dialog_content = getAttribute(targetNode, "data-dialog-content");
  if (dialog_content) {
    trackData.dialog_content = dialog_content;
  }

  var button_name = getAttribute(targetNode, "data-button-name");
  if (button_name) {
    trackData.button_name = button_name;
  }
  let plan_id = getAttribute(targetNode, "data-plan-id");
  if (plan_id) {
    trackData.plan_id = plan_id;
  }
  let create_id = getAttribute(targetNode, "data-create-id");
  if (create_id) {
    trackData.create_id = create_id;
  }
  reporter(trackData);
}
